<div class="warning-feedback">
  <ul class="mb-0">
    <li *ngFor="let w of warnings">{{w}}</li>
  </ul>
</div>
